document.addEventListener('DOMContentLoaded', () => {
  const NA_VALUE = 'N/A';

  function getFieldset(optionName) {
    return [...document.querySelectorAll('fieldset')].find(fieldset => {
      const legend = fieldset.querySelector('legend');
      return legend && legend.textContent.toLowerCase().includes(optionName.toLowerCase());
    });
  }

  function getCheckedValue(optionName) {
    const fieldset = getFieldset(optionName);
    if (!fieldset) return null;

    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    return checkedInput ? checkedInput.value : null;
  }

  function selectValue(optionName, value) {
    const fieldset = getFieldset(optionName);
    if (!fieldset) return;

    const input = [...fieldset.querySelectorAll('input[type="radio"]')]
      .find(input => input.value === value);

    if (input && !input.checked) {
      input.click();
    }
  }

  function selectFirstNotNA(optionName) {
    const fieldset = getFieldset(optionName);
    if (!fieldset) return;

    const input = [...fieldset.querySelectorAll('input[type="radio"]')]
      .find(input => input.value !== NA_VALUE && !input.disabled);

    if (input && !input.checked) {
      input.click();
    }
  }

  function toggleOption(optionName, show) {
    const fieldset = getFieldset(optionName);
    if (fieldset) {
      fieldset.style.display = show ? '' : 'none';
    }
  }

  function hideNALabel(optionName, hide) {
    const fieldset = getFieldset(optionName);
    if (!fieldset) return;

    [...fieldset.querySelectorAll('input[type="radio"]')].forEach(input => {
      if (input.value !== NA_VALUE) return;

      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      if (label) {
        label.style.display = hide ? 'none' : '';
      }
    });
  }

  function updateFrameOnlyOptions() {
    const type = getCheckedValue('Type');
    const isFrameOnly = type === 'Frame Only';

    if (isFrameOnly) {
      selectValue('Net Color', NA_VALUE);
      selectValue('Net Size', NA_VALUE);

      toggleOption('Net Color', false);
      toggleOption('Net Size', false);
    } else {
      selectFirstNotNA('Net Color');
      selectFirstNotNA('Net Size');

      toggleOption('Net Color', true);
      toggleOption('Net Size', true);

      hideNALabel('Net Color', true);
      hideNALabel('Net Size', true);
    }
  }

  document.addEventListener('change', event => {
    if (event.target.matches('input[type="radio"][name="Type"]')) {
      updateFrameOnlyOptions();
    }
  });

  updateFrameOnlyOptions();
});